import React, { useState } from "react";
import "../../styles/intake.css";

const productOptions = [
  // Injectables & Fillers
  "Botox", "Dysport", "Xeomin", "Jeuveau",
  "Juvederm (Ultra, Voluma, Vollure, Volbella)",
  "Restylane (Lyft, Silk, Refyne, Defyne, Kysse, Contour)",
  "Radiesse", "Belotero Balance", "Sculptra", "RHA Collection", "Kybella",
  "Hyperdilute Radiesse", "PRP", "PRF",

  // Skincare Brands
  "Obagi", "SkinCeuticals", "ZO Skin Health", "Alastin Skincare",
  "Epionce", "iS Clinical", "PCA Skin", "EltaMD",
  "Neocutis", "Jan Marini", "Revision Skincare", "Image Skincare",
  "Environ", "Dermalogica", "Glytone", "SkinMedica",

  // Peels & Facials
  "HydraFacial Boosters (ZO, Alastin, Murad, etc.)",
  "VI Peel", "Perfect Derma Peel", "BioRePeel", "Cosmelan", "PRX-T33",
  "SkinBetter Science", "TCA Peel", "Jessner’s Solution",

  // Microneedling Serums
  "Benev Exosomes", "Elevai Exosomes", "TNS Growth Factors", 
  "AQ Solutions Growth Factors", "Hyaluronic Acid", "Copper Peptides", "Vitamin C Serum",

  // Laser & Topical Use
  "Ultrasound Gel", "Topical Lidocaine", "Laser Cooling Gel", "Carbon Peel Gel",

  // Weight Loss & Injections
  "Semaglutide", "Tirzepatide", "B12 Injection", "Lipotropic MIC Injection",
  "Myers Cocktail", "NAD+", "Glutathione IV", "Vitamin C IV",

  // Others
  "CoolSculpting Gel Pad", "Emsculpt Electrodes", "Post-Procedure Recovery Cream",
  "Cicaplast Baume", "Aquaphor", "Alastin Soothe + Protect"
];

export default function ProductSelector({ selected, setSelected }) {
  const [open, setOpen] = useState(false);

  const toggleProduct = (product) => {
    if (selected.includes(product)) {
      setSelected(selected.filter((p) => p !== product));
    } else {
      setSelected([...selected, product]);
    }
  };

  return (
    <div className="dropdown-wrapper">
      <div className="dropdown-header" onClick={() => setOpen(!open)}>
        {selected.length > 0 ? selected.join(", ") : "Select products used..."}
        <span className="arrow">{open ? "▲" : "▼"}</span>
      </div>

      {open && (
        <div className="dropdown-menu">
          {productOptions.map((product) => (
            <label key={product} className="dropdown-item">
              <input
                type="checkbox"
                checked={selected.includes(product)}
                onChange={() => toggleProduct(product)}
              />
              {product}
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
